module.exports = __webpack_public_path__ + "img/yulan.1de271ba.png";